module.exports = __webpack_public_path__ + "static/media/people-1.ba85ea45.svg";